var getCurrentUser = function (state) {
    var uid = state.getIn(['authorize', 'uid']);
    return state.getIn(['user', 'info', uid]);
};
export var authorizeSelector = {
    getCurrentUser: getCurrentUser
};



//////////////////
// WEBPACK FOOTER
// ./src/store/reducers/authorize/authorizeSelector.ts
// module id = 290
// module chunks = 50